import React from 'react';

// This is the recursive component for displaying the file structure.
const FileTree = ({ treeData, handleView, handleEdit, handleDelete }) => {
  const folders = Object.keys(treeData).filter(key => key !== '_files');
  const files = treeData._files || [];

  return (
    <ul className="file-tree-list">
      {folders.map(folderName => (
        <li key={folderName} style={{ display: 'block' }}> {/* Override flex for folder items */}
          <h4 className="folder-name">📂 {folderName}</h4>
          <FileTree
            treeData={treeData[folderName]}
            handleView={handleView}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
          />
        </li>
      ))}

      {files.map(file => (
        <li key={file.path}>
          <span className="file-name">
            {file.fileName === '_index.md' ? 'Main' : file.fileName}
          </span>
          <button onClick={() => handleView(file.path)} className="icon-button" title="View">👁️</button>
          <button onClick={() => handleEdit(file.path)} className="icon-button" title="Edit">✏️</button>
          <button onClick={() => handleDelete(file.path)} className="icon-button" title="Delete">🗑️</button>
        </li>
      ))}
    </ul>
  );
};

export default FileTree;